import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi",
    values: {
      caret_down: "mdi-menu-down",
      send: "mdi-send",
      emoji: "mdi-emoticon-outline",
      chevron_left: "M 20.1 22.8 L 3.9 11.919 L 20.1 1.2 L 20.1 22.8 Z",
      chevron_right: "M 3.9 1.195 L 20.073 12.058 L 3.9 22.76 L 3.9 1.195 Z",
      warning: "mdi-alert",
      check_circle: "mdi-check-circle",
      cancel: "mdi-close-circle",
      play_circle: "mdi-play-circle",
      chevron_double_up: "mdi-chevron-double-up",
      search: "mdi-magnify",
      dots_vertical: "mdi-dots-vertical",
      plus_circle: "mdi-plus-circle-outline",
      delete: "mdi-delete",
      download: "mdi-download",
      arrow_right: "mdi-arrow-right",
      gift: "mdi-gift-outline",
      linkedin: "mdi-linkedin",
      menu:
        "M 0 3 L 24 3 L 24 6 L 0 6 Z M 0 17.4 L 24 17.4 L 24 20.4 L 0 20.4 Z",
      sidebar_close:
        "M 24.247 2.912 L 22.315 0.786 L 12.268 10.06 L 1.835 0.4 L -0.097 2.429 L 10.143 11.992 L -0.097 21.555 L 1.835 23.681 L 12.268 14.021 L 22.315 23.294 L 24.247 21.169 L 14.393 11.992 Z",
      cmf_caret: "M 16.8 8.4 L 11.964 15.6 L 7.2 8.4 L 16.8 8.4 Z"
    }
  },
  theme: {
    themes: {
      light: {
        primary: "#34494C",
        success: "#00924e",
        error: "#a90009",
        red: "#EE3624",
        cmf_blue: "#008AAA",
        cmf_yellow: "#FFCF01",
        cmf_white: "#FFFFFF",
        cmf_lightgray: "#EFF0F1",
        cmf_orange: "#f15d3b",
        cmf_darkgrey: "#34494C"
      }
    }
  }
});
